import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
//all redux

export const getProfile = async (data, onSuccess) => {
  try {
    let response = await _axios.get(END_POINTS.GET_PROFILE, data);
    console.log(response);
    if (onSuccess) onSuccess(response?.data);
    return response?.data;
  } catch (e) {
    console.log("error====>", e);
  }
};

export const editProfile = async (data, onSuccess) => {
  try {
    let response = await _axios.put(END_POINTS.GET_PROFILE, data);
    if (onSuccess) onSuccess(response?.data);
    return response?.data?.data;
  } catch (e) {
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};
